import { render, staticRenderFns } from "./page.vue?vue&type=template&id=bf011d2c&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=bf011d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf011d2c",
  null
  
)

export default component.exports